import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SrAdminDropdownButton extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onClickOption: PropTypes.func.isRequired,
  };

  render() {
    const { title, options, onClickTitle, onClickOption } = this.props;

    return (
      <div className="adminDropdownButton">
        <div className="container">
          <span className="mainAction" onClick={onClickTitle}>
            {title}
          </span>
          <div className="arrowDropDown" />
          <div className="dropdown">
            {options.map((option) => (
              <span
                key={`${option.value}`}
                className="option"
                onClick={() => onClickOption(option.value)}
              >
                {option.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

SrAdminDropdownButton.displayName = 'SrAdminDropdownButton';

export default SrAdminDropdownButton;
